import { detect } from 'detect-browser';

export const copyDocumentElement = (id: string): void => {
  const range = document.createRange();
  const signatureNode = document.getElementById(id);
  if (signatureNode) {
    range.selectNodeContents(signatureNode);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();
    }
  }
};

export const selectDocumentElement = (id: string): void => {
  const range = document.createRange();
  const signatureNode = document.getElementById(id);
  if (signatureNode) {
    range.selectNodeContents(signatureNode);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
};

export const isBrowserChromium = (): boolean => {
  const browser = detect();
  const browserName = browser && browser.name;
  return browserName === 'chrome' || browserName === 'edge-chromium';
};

export const isMacOS = (): boolean => {
  const browser = detect();
  const deviceOS = browser && browser.os;
  return deviceOS === 'Mac OS';
};

export const isIOS = (): boolean => {
  const browser = detect();
  const deviceOS = browser && browser.os;
  return deviceOS === 'iOS';
};

export const isFirefox = (): boolean => {
  const browser = detect();
  const browserName = browser && browser.name;
  return browserName === 'firefox';
};

export const isMobile = (): boolean => {
  const browser = detect();
  const os = (browser && browser.os) ?? '';

  return /iOS|Android OS|BlackBerry OS|Windows Mobile/.test(os);
};
